export default __webpack_public_path__ + "static/media/internet-fail-owl.134985f6.svg";